import { AppConfigKey_FE, ModuleFE_AppConfig } from '@nu-art/thunderstorm-frontend/index';
import { _keys } from '@nu-art/ts-common';
import { ModuleFE_PermissionsAssert } from './modules/ModuleFE_PermissionsAssert.js';
export class PermissionKey_FE extends AppConfigKey_FE {
    static generatePermissionKeysByLevels = (keysMapper) => {
        return _keys(keysMapper).reduce((mapper, currentKey) => {
            if (!mapper[currentKey])
                mapper[currentKey] = new PermissionKey_FE(keysMapper[currentKey]);
            return mapper;
        }, {});
    };
    constructor(key) {
        super(key);
        ModuleFE_PermissionsAssert.registerPermissionKey(this);
    }
    async set(value) {
        // @ts-ignore
        await ModuleFE_AppConfig.set(this, value);
    }
    getAccessLevel() {
        return ModuleFE_PermissionsAssert.getAccessLevel(this);
    }
}
//# sourceMappingURL=PermissionKey_FE.js.map